import Button from '@mui/material/Button';
import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const StyledButton = styled(Button)(({ theme }) => {
  const palette = (theme.vars || theme).palette;
  const brandGlowColor = theme.vars?.palette.background?.brandChannel
    ? `rgba(${theme.vars.palette.background.brandChannel} / 0.33)`
    : alpha(theme.palette.background.brand, 0.33);

  return {
    borderRadius: '1rem',
    lineHeight: 1.2,
    fontFamily: 'Usuzi',
    fontSize: '1.2em',
    padding: theme.spacing(1.5, 3),
    background: palette.background.greenGradient,
    color: palette.text.primary,
    boxShadow: `0 0 0 0 ${palette.background.brand}`,
    transition: 'box-shadow 0.3s ease-in-out',
    '&:hover, &:focus-visible': {
      boxShadow: `0 0 0 10px ${brandGlowColor}`,
      color: palette.text.primary,
    },
    '.MuiButton-icon svg': {
      fontSize: '1.5em',
    },
    '&.xxl': {
      fontSize: '1.5em',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.5vw',
      '.MuiButton-icon svg': {
        fontSize: '2.5vw',
      },
      '&.xxl': {
        fontSize: '2vw',
        padding: theme.spacing(2, 4),
      },
    },
  };
});

const CustomButton = ({ children = null, ...props }) => {
  return (
    <StyledButton {...props}>
      {children}
    </StyledButton>
  );
};

CustomButton.propTypes = {
  children: PropTypes.node,
};

export default CustomButton;
